// Preserve existing sessions and PKCE verifiers across the branded API rollout.
export function productionAuthStorageKey(url: string): string | undefined {
  const origin = url.replace(/\/+$/, "");
  return origin === "https://api.podgo.io" || origin === "https://dshzfnsfkjucxkqnavxy.supabase.co"
    ? "sb-dshzfnsfkjucxkqnavxy-auth-token"
    : undefined;
}
